import React from "react";
import { useTranslation } from "react-i18next";
import { AuthItem, store } from "mydatashare-core";

import {
    AUTH_ITEM_NAME,
    CLIENT_ID,
    REDIRECT_URI,
    SCOPE,
} from "../utils/constants";
import Loading from "./loading";
import { useQuery } from "react-query";
import { fetchAuthItems } from "../utils/client";
import Button from "./button";

const Login = () => {
    const { t } = useTranslation();
    const { status, data } = useQuery("authItems", fetchAuthItems);
    const [authItem, setAuthItem] = React.useState(null);

    React.useEffect(() => {
        if (!authItem && data && status === "success") {
            store.parseApiResponse(data);
            const preselectedAuthItem = AuthItem.asArray(store).find(
                (authItem) => authItem.name === AUTH_ITEM_NAME
            );
            if (!preselectedAuthItem) {
                console.error(
                    `AuthItems did not contain an auth_item with name "${AUTH_ITEM_NAME}"`
                );
                throw new Error("Error fetching auth_items");
            }
            localStorage.setItem("authItemUuid", preselectedAuthItem.uuid);
            setAuthItem(preselectedAuthItem);
        }
    }, [authItem, data, status]);

    if (status === "loading" || status === "idle") {
        return <Loading />;
    }

    if (status === "error") {
        throw new Error("Error fetching auth_items");
    }

    if (status !== "success") {
        throw new Error(`Unhandled Auth Items query status: ${status}`);
    }

    return (
        <>
            <h1>{t("Login page header")}</h1>
            <p>{t("Login page intro")}</p>
            <p>{t("Login page intro 2")}</p>
            <p>{t("Login page instructions")}</p>
            <Button.Area>
                <div>
                    {authItem && (
                        <Button
                            text={t("Log in")}
                            onClick={() =>
                                authItem.performAuthorization(
                                    CLIENT_ID,
                                    REDIRECT_URI,
                                    SCOPE
                                )
                            }
                        />
                    )}
                </div>
            </Button.Area>
        </>
    );
};

export default Login;
